/**
 * T-03 (conversion audit) — first-touch signup attribution.
 *
 * Landing CTAs arrive as /?utm_source=landing&utm_content=<cta>#signup.
 * The hash-router never reloads the page, but a later in-app navigation
 * can rewrite the URL, so the query string + referrer are captured ONCE
 * at boot into sessionStorage and read back when the register payload is
 * built. First touch wins: an existing capture is never overwritten.
 */

const KEY = 'heist_attribution';

export function captureAttribution() {
    try {
        if (sessionStorage.getItem(KEY)) return;
        const params = new URLSearchParams(window.location.search);
        const attr = {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((k) => {
            const v = params.get(k);
            if (v) attr[k] = v.slice(0, 200);
        });
        const ref = document.referrer || '';
        if (ref && !ref.startsWith(window.location.origin)) attr.referrer = ref.slice(0, 500);
        attr.landing_url = window.location.href.slice(0, 500);
        sessionStorage.setItem(KEY, JSON.stringify(attr));
    } catch (_) { /* storage unavailable — attribution is best-effort */ }
}

export function getAttribution() {
    try {
        const raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
}
